export default __webpack_public_path__ + "static/Крысиные бега_7-65efa561a5a842634e1d3bb7b3b783b9.jpg";